import { render, staticRenderFns } from "./Form51.vue?vue&type=template&id=1460a4f3&scoped=true"
import script from "./Form51.vue?vue&type=script&lang=ts"
export * from "./Form51.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=1460a4f3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460a4f3",
  null
  
)

export default component.exports